
import AlacakForm from "@/components/forms/AlacakForm.vue";
import {Component, Prop, Vue, Watch} from "vue-property-decorator";
import {TakipTalebiEntity} from "@/entity/TakipTalebiEntity";
import DetailDialog from "@/components/dialogs/DetailDialog.vue";
import FormDialog from "@/components/dialogs/FormDialog.vue";
import DeleteDialog from "@/components/dialogs/DeleteDialog.vue";
import {IlamsizBelgeTuru} from "@/enum/IlamsizBelgeTuru";
import AlacakKopyalaForm from "@/components/forms/AlacakKopyalaForm.vue";
import AlacakKalemiDetayForm from "@/components/takip/form/AlacakKalemiDetayForm.vue";
import {AlacakEntity} from "@/entity/AlacakBelgeler/AlacakEntity";
import AlacakKalemiEntity from "@/entity/AlacakBelgeler/AlacakKalemiEntity";
import {ParaBirimiEntity} from "@/entity/ParaBirimiEntity";
import TakipKurForm from "@/components/forms/TakipKurForm.vue";
import {TakipEntity} from "@/entity/TakipEntity";
import {TakipDurumu} from "@/enum/TakipDurumu";
import {ParaBirimi} from "@/enum/ParaBirimi";
import {TakipTarihliKurEntity} from "@/entity/TakipTarihliKurEntity";
import {TakipTipi} from "@/enum/TakipTipi";
import {AlacakBelgeTuru} from "@/enum/AlacakBelgeTuru";

@Component({
  components: {
    TakipKurForm,
    FormDialog,
    AlacakForm,
    AlacakKopyalaForm,
    AlacakKalemiDetayForm,
    DeleteDialog,
    DetailDialog,
  },
})
export default class AlacakList extends Vue {
  @Prop({required: true, default: () => []}) alacaklar!: any;
  @Prop() takip!: any;

  // ---- STATE
  alacakDetay: any = {};
  alacakFormDisable: boolean = false;
  takipDurumu = TakipDurumu;
  TakipTipi = TakipTipi;
  takipTarihliKur: any[] = [];
  alacakKalemleri: any[] = [];
  ihtarlar: any[] = [];
  protestolar: any[] = [];
  tasinmazlar: any[] = [];
  tasinirlar: any[] = [];
  AlacakBelgeTuru = AlacakBelgeTuru;

  // Re-mount anahtarı (toolbar + kart)
  toolbarKey = 0;

  // Race condition önleme token'ı
  private _lastTipFetchToken: number | null = null;

  headers = [
    {text: "Borcun Sebebi", value: "belge_turu.isim"},
    {text: "Belge Giriş Tarihi", value: "tanzim_tarihi"},
    {text: "Faiz Başlangıç Tarihi", value: "faiz_baslangic_tarihi"},
    {text: "Açıklama", value: "aciklama"},
    {text: "Toplam Alacak Kalemi", value: "tutar", width: 140},
    {text: "İşlemler", value: "actions", sortable: false, width: 180, align: 'center'},
  ];

  paraBirimleri:any[] =  []

  async getParaBirimleri(){
    let response = await this.$helper.requestWithCache("/api/v1/para-birimi-picker");
    this.paraBirimleri = response.data;
  }

  mounted(){
    this.getParaBirimleri();
  }

  // ---- COMPUTEDS
  get alacakFormDisabled() {
    return this.takip?.takip_durumu === TakipDurumu.kapali;
  }

  get toolbarTitle() {
    const talep = this.takip?.talepler?.[0] || null;
    const tip   = talep?.takip_tipi || {};

    // Tüm olası alanlar için fallback
    const no   = tip.takip_tipi_no ?? talep?.takip_tipi_no ?? tip.yeni_no ?? tip.no ?? tip.takip_no ?? null;
    const eski = tip.takip_tipi_eski_no ?? talep?.takip_tipi_eski_no ?? tip.eski_no ?? tip.old_no ?? null;
    const isim = tip.isim ?? talep?.takip_tipi_isim ?? tip.ad ?? tip.name ?? null;

    if (no)   return `Alacaklar ${no}${eski ? ` (${eski})` : ''}`;
    if (isim) return `Alacaklar - ${isim}`;
    return 'Alacaklar';
  }

  // watcher/anahtar için id
  get _takipTipiId() {
    return this.takip?.talepler?.[0]?.takip_tipi_id ?? null;
  }

  get kiraKontratlari() {
    const out: any[] = [];
    if (!this.alacaklar || !Array.isArray(this.alacaklar)) return out;
    this.alacaklar.forEach((item: any) => {
      if (item.alacak_belge_turu_id == IlamsizBelgeTuru.kiraKontrat) out.push(item);
    });
    return out;
  }

  // ---- WATCHERS
  @Watch("alacaklar")
  onValueChange() {
    if (!this.alacaklar || !Array.isArray(this.alacaklar)) return;
    const kiraKontrati = this.kiraKontratlari;
    this.$emit("kira-kontrati", kiraKontrati);
    if (this.takip?.id && this.takipTarihliKur.length > 0) this.setKurAlanlari();
  }

  @Watch('takip.talepler', { deep: true })
  onTaleplerChanged() {
    this.bumpToolbar();
  }

  @Watch('_takipTipiId')
  async onTakipTipiIdChanged(newId: number | null) {
    if (!newId || !this.takip?.talepler?.[0]) return;

    // Hızlı seçimlerde yarış koşulunu engelle
    const token = Date.now();
    this._lastTipFetchToken = token;

    // mevcut obje yanlışsa ya da yoksa hydrate et
    const cur = this.takip.talepler[0].takip_tipi;
    if (!cur || cur.id !== newId) {
      try {
        const res = await this.$http.get(`/api/v1/takip-tipi/${newId}`);
        if (this._lastTipFetchToken !== token) return; // eski cevap, yoksay
        const normalized = this.normalizeTakipTipi(res.data);
        this.$set(this.takip.talepler[0], 'takip_tipi', normalized);
      } catch (e) {
        // en azından boş kalmasın
        this.$set(this.takip.talepler[0], 'takip_tipi', { takip_tipi_no: newId });
      }
    }
    this.bumpToolbar();
  }

  // ---- METHODS
  private bumpToolbar() {
    this.toolbarKey = Date.now();
  }

  private normalizeTakipTipi(raw: any) {
    const no   = raw?.takip_tipi_no ?? raw?.yeni_no ?? raw?.no ?? raw?.takip_no ?? null;
    const eski = raw?.takip_tipi_eski_no ?? raw?.eski_no ?? raw?.old_no ?? null;
    const isim = raw?.isim ?? raw?.ad ?? raw?.name ?? null;
    return { ...raw, takip_tipi_no: no, takip_tipi_eski_no: eski, isim };
  }

  getParaBirimiSembol(paraBirimiId: number){
    const paraBirimi:any = this.paraBirimleri.find((p:any) => p.id === paraBirimiId);
    if (!paraBirimi) return 'TL';
    return paraBirimi.id !== ParaBirimi.TRY ? paraBirimi.kisa_isim : 'TL';
  }

  addAlacak(){
    this.$http.get('/api/v1/takip/' + this.$route.params.id + '/takip-tarihli-kur').then((response)=>{
      this.takipTarihliKur = response.data.takipTarihliKur;
    })
  }

  getAlacakDetay(id:number){
    this.$http.get('/api/v1/takip/' + this.$route.params.id + '/alacak/' + id).then((response)=>{
      this.alacakDetay = response.data;
    }).then(()=>{
      if (this.alacakDetay.alacak_belge_turu_id !== this.AlacakBelgeTuru.cocukTeslimi &&
          this.alacakDetay.alacak_belge_turu_id !== this.AlacakBelgeTuru.kisiselIliski) {
        this.getAlacakKalemleri(id);
      }
      if (this.alacakDetay.ihtar_var_mi){
        this.getIhtarlar(id)
      }else{
        this.ihtarlar = []
      }
      if (this.alacakDetay.protesto_var_mi){
        this.getProtestolar(id)
      }else{
        this.protestolar = []
      }
      if(this.alacakDetay.tasinir_var_mi){
        this.getTasinirlar(id)
      }else{
        this.tasinirlar = []
      }
      if(this.alacakDetay.tasinmaz_var_mi){
        this.getTasinmazlar(id)
      }else{
        this.tasinmazlar = []
      }
    })
  }

  getAlacakKalemleri(id:number){
    this.$http.get('/api/v1/takip/' + this.$route.params.id + '/alacak/' + id + '/alacak-kalemleri').then((response)=>{
      this.alacakKalemleri = response.data;
    })
  }

  getIhtarlar(id:number){
    this.$http.get('/api/v1/alacak/' + id + '/ihtarlar').then((response)=>{
      this.ihtarlar = response.data;
    })
  }
  getProtestolar(id:number){
    this.$http.get('/api/v1/alacak/' + id + '/protestolar').then((response)=>{
      this.protestolar = response.data;
    })
  }
  getTasinmazlar(id:number){
    this.$http.get('/api/v1/alacak/' + id + '/tasinmazlar').then((response)=>{
      this.tasinmazlar = response.data;
    })
  }
  getTasinirlar(id:number){
    this.$http.get('/api/v1/alacak/' + id + '/tasinirlar').then((response)=>{
      this.tasinirlar = response.data;
    })
  }

  // TODO: İkili takipte senkronize olmayacağı için sorun çıkarabilir
  setKurAlanlari() {
    if (!this.alacaklar || !Array.isArray(this.alacaklar)) return;

    let dovizler: Array<{ para_birimi_id: number, para_birimi: ParaBirimiEntity|undefined }> = [];

    this.alacaklar.forEach((alacak: AlacakEntity) => {
      if (!dovizler.find((doviz) => (doviz.para_birimi_id == alacak.para_birimi_id)) && alacak.para_birimi_id && alacak.para_birimi_id != ParaBirimi.TRY)
        dovizler.push({para_birimi_id: alacak.para_birimi_id, para_birimi: alacak.para_birimi});

      if (alacak.asil_alacaklar && Array.isArray(alacak.asil_alacaklar)) {
        alacak.asil_alacaklar.forEach((alacakKalemi: AlacakKalemiEntity) => {
          if (!dovizler.find((doviz) => (doviz.para_birimi_id == alacakKalemi.para_birimi_id)) && alacakKalemi.para_birimi_id && alacakKalemi.para_birimi_id != ParaBirimi.TRY)
            dovizler.push({para_birimi_id: alacakKalemi.para_birimi_id, para_birimi: alacakKalemi.para_birimi});
        });
      }
    });

    if (this.takip.takip_tarihli_kur && Array.isArray(this.takip.takip_tarihli_kur)) {
      this.takip.takip_tarihli_kur.forEach((kur: TakipTarihliKurEntity, index:any) => {
        if (!dovizler.find((doviz) => (doviz.para_birimi_id == kur.para_birimi_id)))
          this.$http.delete('/api/v1/takip-tarihli-kur/' + kur.id).then(() => (this.takip.takip_tarihli_kur.splice(index, 1)));
      });
    }
  }

  load() {
    this.$emit("load");
  }

  getAlacakKalemiToplamlari(alacak: AlacakEntity) {
    let alacakKalemiToplamlari: Array<{ para_birimi_id: number, tutar: number, para_birimi: ParaBirimiEntity|undefined }> = [];
    alacak.asil_alacaklar.forEach((alacak_kalemi: AlacakKalemiEntity) => {
      let toplamlar = alacakKalemiToplamlari.find((toplam) => (toplam.para_birimi_id == alacak_kalemi.para_birimi_id))
      if (toplamlar) {
        toplamlar.tutar += Number(alacak_kalemi.tutar);
      } else {
        alacakKalemiToplamlari.push({
          para_birimi_id: alacak_kalemi.para_birimi_id,
          tutar: Number(alacak_kalemi.tutar),
          para_birimi: alacak_kalemi.para_birimi
        });
      }
    })
    let tutarlar: Array<any> = [];
    alacakKalemiToplamlari.forEach((alacakKalemiToplami: { para_birimi_id: number, tutar: number, para_birimi: ParaBirimiEntity|undefined }) => (tutarlar.push(this.$helper.tutarStr(alacakKalemiToplami.tutar, alacakKalemiToplami.para_birimi))));
    return tutarlar;
  }

  // ---- SUCCESS HANDLERS: Yenileme tetik
  handleFormSuccess(alacak?: any) {
    this.load();
    this.$emit('added', alacak);
    this.bumpToolbar();              // soft re-render
  }

  handleDeleteSuccess(alacak?: any) {
    this.load();
    this.$emit('added', alacak);
    this.bumpToolbar();              // soft re-render
  }
}
